import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_042.jpg';
page.images = [
  {
    imageId: 'page042_zoom0',
    rectangle: {
      x: 138,
      y: 1472,
      width: 1630,
      height: 815,
    },
    imageSrc: 'images/page042/042 2.jpg',
  },
  {
    imageId: 'page042_zoom1',
    rectangle: {
      x: 612,
      y: 511,
      width: 1162,
      height: 820,
    },
    imageSrc: 'images/page042/042 1.jpg',
  },
];
page.word = [
  {
    id: 'page021_game1',
    icon: 'ikona_cw1',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    wordObj: {
      text: 'Podpisz zdjęcia. Kliknij w ikonę programu Word.',
      audio: 'files/page021/z21c1.mp3',
      item: {
        path: 'informatyka/files/page021/21_ćw_1_word.docx',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page021_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    wordObj: {
      text: 'Przepisz podane wyrazy. Kliknij w ikonę programu Word.',
      audio: 'files/page021/z21c2.mp3',
      item: {
        path: 'informatyka/files/page021/21_ćw_2_word.docx',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page021_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    wordObj: {
      text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
      audio: 'files/page021/z21c3.mp3',
      item: {
        path: 'informatyka/files/page021/21_ćw_3_word.docx',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.games = [
  // {
  //   id: 'page021_game1',
  //   tooltip: '',
  //   icon: 'ikona_cw1',
  //   pos: {
  //     x: LEFT,
  //     y: 0,
  //   },
  // },
  // {
  //   id: 'page010_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 200,
  //   },
  // },
  // {
  //   id: 'page019_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 400,
  //   },
  // },
  {
    id: 'page021_game4',
    tooltip: '',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
  },
  {
    id: 'page042_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: LEFT,
      y: 1040,
    },
    item: {
      id: 'page042_game10',
    },
    rectangle: {
      id: 'page042_rect0',
    },
  },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 800,
  //   },
  // },
];
page.rectangle = [
  {
    id: 'page042_rect0',

    tooltip: '',

    linked: ['page042_game10'],
    x: 120,
    y: 691,
    width: 463,
    height: 622,
  },
];
export default page;
